// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/impostazioni/openapi/configurazione?societaId=N',
    requestBody: null,
    response: '{ success: true, data: Configurazione | null }'
  },
  {
    method: 'GET',
    endpoint: '/api/impostazioni/openapi/servizi-catalogo',
    requestBody: null,
    response: '{ success: true, data: ServizioCatalogo[] }'
  },
  {
    method: 'GET',
    endpoint: '/api/impostazioni/openapi/log?societaId=N&dal=&al=&page=1&limit=50',
    requestBody: null,
    response: '{ success: true, data: { log: LogEntry[], pagination: { page, limit, total, totalPages } } }'
  },
  {
    method: 'PUT',
    endpoint: '/api/impostazioni/openapi/configurazione',
    requestBody: '{ societaId, ambienteAttivo, emailAccount, apiKeyProduzione, apiKeySandbox, attivo, note }',
    response: '{ success: true, data: Configurazione }'
  },
  {
    method: 'POST',
    endpoint: '/api/impostazioni/openapi/configurazione/verifica-credenziali',
    requestBody: '{ societaId, ambiente? }',
    response: '{ success: true, data: { ok, latenzaMs, httpStatus, ambiente, creditoResiduo, messaggio } }'
  },
  {
    method: 'POST',
    endpoint: '/api/impostazioni/openapi/servizi',
    requestBody: '{ societaId, codiceCatalogo, urlProduzione?, urlSandbox?, attivo?, note? }',
    response: '{ success: true, data: Servizio }'
  },
  {
    method: 'PUT',
    endpoint: '/api/impostazioni/openapi/servizi/:id',
    requestBody: '{ urlProduzione?, urlSandbox?, attivo?, note? }',
    response: '{ success: true, data: Servizio }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/impostazioni/openapi/servizi/:id',
    requestBody: null,
    response: '{ success: true }'
  },
  {
    method: 'POST',
    endpoint: '/api/impostazioni/openapi/servizi/:id/keepalive',
    requestBody: '{ ambiente? }',
    response: '{ success: true, data: { ok, latenzaMs, httpStatus, ambiente, messaggio } }'
  },
  {
    method: 'POST',
    endpoint: '/api/impostazioni/openapi/servizi/:id/genera-token',
    requestBody: '{ ambiente?, ttlGiorni? }',
    response: '{ success: true, data: { ok, latenzaMs, httpStatus, ambiente, scadenza, messaggio } }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
